/**
 * Determines whether the given element is out of document (default) or window view
 */
export const isOutOfView = (
  element: Element,
  rect?: DOMRect,
  checkOutOfWindow?: boolean,
): boolean => {
  if (!rect) {
    rect = element.getBoundingClientRect();
  }

  let windowHeight = 0;
  let windowWidth = 0;
  const isElementPositionFixed =
    window.getComputedStyle(element).position === 'fixed';

  // isWindowMode - when we search within the window (i.e., viewport)
  // When an HTML element has position: fixed, it's removed from the normal document flow and positioned relative to the viewport (browser window) rather than the page
  const isWindowMode = checkOutOfWindow || isElementPositionFixed;

  if (isWindowMode) {
    windowHeight = window.innerHeight || document.documentElement.clientHeight;
    windowWidth = window.innerWidth || document.documentElement.clientWidth;
  } else {
    // Different browsers can give different values, so we choose a maximum one
    windowHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight,
    );

    windowWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.body.clientWidth,
      document.documentElement.clientWidth,
    );
  }

  const scrollY = isWindowMode ? 0 : window.scrollY;
  const scrollX = isWindowMode ? 0 : window.scrollX;

  const elementTop = rect.top + scrollY;
  const elementBottom = rect.bottom + scrollY;
  const elementLeft = rect.left + scrollX;
  const elementRight = rect.right + scrollX;

  return (
    elementBottom < 1 || // Element is above the boundaries
    elementTop > windowHeight || // Element is below the boundaries
    elementRight < 1 || // Element is to the left of the boundaries
    elementLeft > windowWidth // Element is to the right of the boundaries
  );
};
